import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";
import { OVIDProvider } from '@outdoor-voices/ui/dist/utils/customer/OVIDProvider';
import AccountNav from '@outdoor-voices/ui/dist/components/AccountNav';
import React from 'react';
import ReactDOM from 'react-dom';
import { COOKIE_DOMAIN, JWT_COOKIE_NAME } from './constants';
import { OV_ID_URL } from '../../config/theme';
import { getProgram, getProgramLoaded, setProgram, setProgramLoaded } from './utils';
import OVIDClient from './OVIDClient';
import TeamPostActivation from './components/TeamPostActivation';
import TeamPreActivation from './components/TeamPreActivation';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var Program = /*#__PURE__*/_createClass(function Program() {
  _classCallCheck(this, Program);
});

_defineProperty(Program, "init", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  var _window$OV, CUSTOMER, MINIMIZE_REQUESTS, email, client, query, response;

  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _window$OV = window.OV, CUSTOMER = _window$OV.CUSTOMER, MINIMIZE_REQUESTS = _window$OV.MINIMIZE_REQUESTS;
          email = CUSTOMER.email; // Don't load if we already loaded and no program was stored

          if (!(MINIMIZE_REQUESTS || getProgramLoaded() && !getProgram())) {
            _context.next = 4;
            break;
          }

          return _context.abrupt("return");

        case 4:
          client = new OVIDClient();
          query = "\nquery Account {\n  eligiblePrograms: programs(eligible: true) {\n    id\n    title\n    questions\n    preActivationDescription\n    preActivationTitle\n  }\n  programs {\n    id\n    title\n    postActivationDescription\n    postActivationTitle\n    postActivationCTA\n    postActivationURL\n    promoCode\n  }\n  schoolColor(email: \"".concat(email, "\") {\n    id\n    primaryColor\n    secondaryColor\n    name\n  }\n}\n");
          _context.next = 8;
          return client.query(query);

        case 8:
          response = _context.sent;
          Program.renderProgram(response.data);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
})));

_defineProperty(Program, "renderProgram", function (_ref2) {
  var eligiblePrograms = _ref2.eligiblePrograms,
      programs = _ref2.programs,
      schoolColor = _ref2.schoolColor;

  if (eligiblePrograms.length === 0 && programs.length === 0) {
    return;
  }

  if (programs.length > 0) {
    ReactDOM.render( /*#__PURE__*/_jsx(_Fragment, {
      children: programs.map(function (_ref3) {
        var id = _ref3.id,
            postActivationDescription = _ref3.postActivationDescription,
            postActivationTitle = _ref3.postActivationTitle,
            postActivationCTA = _ref3.postActivationCTA,
            postActivationURL = _ref3.postActivationURL;
        return /*#__PURE__*/_jsx(TeamPostActivation, {
          postActivationDescription: postActivationDescription,
          postActivationCta: postActivationCTA,
          postActivationUrl: postActivationURL,
          postActivationTitle: postActivationTitle
        }, id);
      })
    }), document.getElementById('programs')); // Store the program in a cookie

    setProgram(_objectSpread(_objectSpread({}, schoolColor), {}, {
      promoCode: programs[0].promoCode
    }));
  }

  if (eligiblePrograms.length > 0) {
    ReactDOM.render( /*#__PURE__*/_jsx(_Fragment, {
      children: eligiblePrograms.map(function (_ref4) {
        var id = _ref4.id,
            questions = _ref4.questions,
            preActivationDescription = _ref4.preActivationDescription,
            preActivationTitle = _ref4.preActivationTitle;
        var profileQuestions = JSON.parse(questions);
        return /*#__PURE__*/_jsx(TeamPreActivation, {
          programId: id,
          preActivationDescription: preActivationDescription,
          preActivationTitle: preActivationTitle,
          profileQuestions: profileQuestions.questions
        }, id);
      })
    }), document.getElementById('eligible-programs'));
  } else {
    // Track that we loaded the programs and there were no eligible ones
    setProgramLoaded();
  }
});

function init() {
  Program.init(); // Initialize the account nav with the correct configuration

  ReactDOM.render( /*#__PURE__*/_jsx(OVIDProvider, {
    domain: COOKIE_DOMAIN,
    name: JWT_COOKIE_NAME,
    url: OV_ID_URL,
    children: /*#__PURE__*/_jsx(AccountNav, {
      ovIDURL: OV_ID_URL,
      shopifyURL: "/"
    })
  }), document.getElementById('account-nav'));
}

export default init;